import component from './i18nHintsTranslates.vue'

export default component
